<template>
  <div>
    <!--<Header>Math.floor((Math.random() * 8) + 0)</Header> background: 
                'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), '+
                'url(\''+$store.state.authInfo.backgrounImage[0]+'\') repeat  '+
                'right top', backgroundSize: 'cover', backgroundPosition: 'center',  -->
    <div
        :style="{ width: '100wh', height: '100vh', display: 'flex', backgroundColor: 'black'}">
            
            <div class="hero-text">
                
                <router-view></router-view>    

            </div>
            
    </div>
<!--<Footer></Footer>-->
    
  </div>
</template>

<script>

export default {
  data () {
    return {
      
    }
  },
  components: {
  },
  created() {
      this.$store.dispatch('fetchEventTypes')
      this.$store.dispatch('fetchFinancialConfiguration')
  }
}
</script>

<style>

.label {
  font-size: 13px;
  font-weight: 100;
}

.container-box {
  width: 500px; 
  margin: 0px 0 auto; 
  box-shadow: 0px 8px 16px 0px #383838; 
  opacity: 0.9;
  
}

.container-box-1 {
  width: 800px; 
  margin: 130px 0 auto; 
  box-shadow: 0px 8px 16px 0px #383838; 
  opacity: 0.9;
  
}

.hero-image {
  /*background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://donquijote.b-cdn.net/birthday-cake-blur-catering-903415.jpg') repeat  right top;*/
  background-size: cover;
  background-position: center;
  width: 100wh;
  height: 100vh;
  display: flex;
  background-color: black;
}

.hero-text {
  text-align: center;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  
}

body, html {
  background-color: #21111e;
  
}

.col-5 {
    float: left;
    width: 5%;
}

.col-10 {
    float: left;
    width: 10%;
}

.col-15 {
    float: left;
    width: 15%;
}

.col-20 {
    float: left;
    width: 20%;
}

.col-25 {
    float: left;
    width: 25%;
}

.col-30 {
    float: left;
    width: 30%;
}
.col-35 {
    float: left;
    width: 35%;
}

.col-40 {
    float: left;
    width: 40%;
}

.col-45 {
    float: left;
    width: 45%;
}

.col-50 {
    float: left;
    width: 50%;
}

.col-60 {
    float: left;
    width: 60%;
}
.col-65 {
    float: left;
    width: 65%;
}

.col-70 {
    float: left;
    width: 70%;
}

.col-75 {
    float: left;
    width: 75%;
}

.col-80 {
    float: left;
    width: 80%;
}

.col-85 {
    float: left;
    width: 85%;
}
.col-100 {
    float: left;
    width: 100%;
}

/* Clear floats after the columns */
.row:after {
    content: "";
    display: table;
    clear: both;
    padding-top: 15px;

}

.footer-class {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  font-size: 12px;
  color: white;
  background-color: #715b4e;
  text-align: center;
   
}

.header-class {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background-color: #715b4e;
  text-align: center;   
  z-index: 9999;
  height: 100px;
  background: rgba(255,255,255,0.1);
}


.bottom-information {
  width: 500px; 
  margin: 0 auto;
}

.header-card {
  float: left;
  text-align: right;
  right: -870px;
  position: relative;
}

.testimonials {
  width: 500px; 
  margin: 0 auto; 
  border-width: 1px; 
  border-style: solid; 
  border-color: white; 
  padding: 5px;
}

.radioClass {

}
.radioClass:hover {
  color: white;
}

.gobackbutton {
   color: #fff; 
   font-size: 20px; 
   font-weight: bold; 
   border-style: dotted; 
   border-color: #eee; 
   border-width: 0.5px; padding: 5px;
}

.gobackbutton:hover {
   color: #7bb056;    
}

.buttonClass {
  background: rgba(255,255,255,0.3);
  border: none;
  outline: 0;
  display: inline-block;
  padding: 10px 40px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  font-size: 25px;
}

.buttonClass div {
  padding: 5px; 
  background-color: #7bb056; 
  color: white; 
  font-size: 20px; 
  font-weight: bold;
}

.nativeinput {
  font-size: 0.85rem;
  font-weight: 400;
  height: 30px;
  width: 100%;
  padding: 5px;
  outline: #696969; 
  border-radius: 5px;
}

@media screen and (max-width: 600px) {
    .col-5, .col-10, .col-15, .col-25, .col-20, .col-30, .col-40, .col-45, .col-50, .col-60, .col-75, .col-80, .col-85, .col-100 {
        width: 100%;
        margin-top: 0;
    }
    .container-box {
      width: 300px;
      
    }
    .container-box-1 {
      width: 300px;
    }
    /*.hero-image {
      height: 320vh;
    }*/
    .bottom-information {
      /*top: 420px; position: relative;*/
      width: 300px; 
      margin: 0 auto;
    }
    .testimonials {
      width: 300px; 
    }

}

</style>



// WEBPACK FOOTER //
// src/App.vue